import { Component, OnInit, ViewChild } from '@angular/core';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { Course } from 'src/app/models/course';
import { MatTableDataSource, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-practice-content',
  templateUrl: './practice-content.component.html',
  styleUrls: ['./practice-content.component.scss']
})
export class PracticeContentComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public practiceContent:Course[];
  public datasource:MatTableDataSource<any>;
  displayedColumns: string[] = ['title', 'published'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public getPracticeContent(){
    this._practice.getPracticeContent(this.practiceId).subscribe(
      res=>{
        this.practiceContent=res;
        this.datasource = new MatTableDataSource<any>(this.practiceContent);
        this.datasource.paginator=this.paginator;
      }
    );
  }

  public addContent(){
    if(!confirm('Confirm that you want to add a new Practice Content Course.')) return;
    this._practice.createPracticeContent(this.practiceId).subscribe(
      res=>{
        this.practiceContent=res;
        this.getPracticeContent();
      }
    );
  }

  public navigateToCourse(row){
    this._router.navigate(['/practices/'+this.practiceId+'/content/'+row.id]);
  }

  ngOnInit() {
    this.getPractice();
    this.getPracticeContent();
  }

}
